import React from "react";
import axios from "axios";

import StudentsIndexlinks from "./indexLinks";
import { downloadFile } from "../../functions.js";

export default class StudentsCertificates extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loaded: false
        };
    }

    getResults = () => {
        axios
            .all([axios.get("/v1/students/" + this.props.params.itemID + "/"), axios.get("/v1/users/" + this.props.params.itemID + "/competenceprofiles/")])
            .then(
                axios.spread((student, cpData) => {
                    this.setState({
                        loaded: true,
                        ...student.data,
                        competenceProfiles: cpData.data
                    });
                })
            )
            .catch((error) => {
                console.log(error);
            });
    };

    componentDidMount() {
        this.getResults();
    }

    render() {
        let resultHTML = <h2>Ophalen van gegevens...</h2>;

        if (this.state.loaded) {
            if (this.state.competenceProfiles.results) {
                let resultRows = [];

                this.state.competenceProfiles.results.forEach((cp) => {
                    // Check if the competenceprofile has been achieved
                    // Only then a certificate will be able to download for the end user
                    if (cp.achieved) {
                        resultRows.push(
                            <tr key={cp.uuid}>
                                <td>
                                    <strong>{cp.name}</strong>
                                    {cp.description ? (
                                        <span className="lighter">
                                            <br />
                                            {cp.description}
                                        </span>
                                    ) : (
                                        ""
                                    )}
                                </td>
                                <td>{cp.progress_percentage}%</td>
                                <td>
                                    <span
                                        className="btn btn-secondary"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            downloadFile(
                                                `${APP_CONFIG.api_url}/v1/users/${this.props.params.itemID}/competenceprofiles/${cp.uuid}/certificate/`,
                                                `${cp.name}.pdf`
                                            );
                                        }}
                                    >
                                        Download certificaat
                                    </span>
                                    <i
                                        className="fa fa-refresh pointer"
                                        title="Certificaat opnieuw genereren"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            downloadFile(
                                                `${APP_CONFIG.api_url}/v1/users/${this.props.params.itemID}/competenceprofiles/${cp.uuid}/certificate/?rerender=true`,
                                                `${cp.name}.pdf`
                                            );
                                        }}
                                    ></i>
                                </td>
                            </tr>
                        );
                    }
                });

                if (resultRows.length > 0) {
                    resultHTML = (
                        <table className="table table-hover mt-3">
                            <thead>
                                <tr>
                                    <th>Competentieprofiel</th>
                                    <th>Behaalde percentage</th>
                                    <th>Certificaat</th>
                                </tr>
                            </thead>
                            <tbody>{resultRows}</tbody>
                        </table>
                    );
                } else {
                    // We have 0 results
                    resultHTML = <h2>Er zijn nog geen certificaten voor deze cursist.</h2>;
                }
            }
        }

        return (
            <div>
                <StudentsIndexlinks
                    title={this.state.full_name}
                    nibhv_number={this.state.nibhv_number}
                    studentUUID={this.props.params.itemID}
                    buttons={[{ title: "Cursist bewerken", link: "/students/edit/" + this.props.params.itemID, classname: "btn btn-primary" }]}
                />

                {resultHTML}
            </div>
        );
    }
}
